import { useNavigate } from 'react-router-dom';

import { InfoContent } from './components';

import { Card, NavBar } from '@/components';
import ROUTES from '@/router/routes';
import { GENERICS_WORDS } from '@/utils';

export const InfoFCup = () => {
  const navigate = useNavigate();
  return (
    <NavBar
      mobile={{
        centerContent: {
          title: GENERICS_WORDS.friendsCup,
        },
        leftContent: {
          backAction: () => {
            navigate(ROUTES.friendsCup.home);
          },
        },
      }}
    >
      <div className="px-6 pt-4 ">
        <Card className="!px-6 !pb-8 !w-auto !pt-4 bg-white">
          <InfoContent />
        </Card>
      </div>
    </NavBar>
  );
};
